import {bindActionCreators, compose} from 'redux';
import {reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {actions} from './../../../redux/actions';
import {validations} from './../../../lib/validations';
import {withRouter} from 'react-router';

const mapStateToProps = (state: any) => ({
  news: state.news,
  selectedForm: state.form,
  initialValues: {isDisclosed: false},
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    actions: {
      news: bindActionCreators(actions.news, dispatch),
    },
  };
};

export const enhance: any = compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'NewsCreate',
    validate: validations.news,
  }),
  withRouter
);
